<template>
    <el-dialog
      title=""
      :visible="dialogVisible"
      width="30%"
      center>
      <div class="dialog-content">
        <p class="dialog-content__comfirm">是否确认取消布置？</p>
        <p class="dialog-content__detail">取消后，将不会保留之前所选内容</p>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleNoArrange" style="margin-right:20px;">不再布置</el-button>
        <el-button type="primary"
         @click="handleGoArrange">继续布置</el-button>
      </span>
    </el-dialog>
</template>

<script>
export default {
  name: 'KnowledgeDialog',
  props: {
    dialogVisible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
    };
  },
  methods: {
    handleGoArrange() {
      this.$emit('handleClose', true);
    },
    handleNoArrange() {
      this.$emit('handleClean');
    },
  },

};
</script>

<style lang="scss" scoped>
.dialog-content{
    text-align: center;
    font-size: 20px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    line-height: 36px;
    color: #111F2C;
  }
  /deep/ .el-dialog {
    background: #FFFFFF;
    border-radius: 16px;
  }
</style>
